'use client';

import { c as _c } from "react/compiler-runtime";
import { Flag } from '@7f-ui/components/flag/flag';
import { formatGermanNumber, formatMonthYear } from '@utils/utils-format';
type PartnerIntroProps = {
  tagline?: string | null;
  city?: string | null;
  name: string;
  memberSince?: string | null;
  experienceCount: number;
};
export function PartnerIntro(t0) {
  const $ = _c(18);
  const {
    tagline,
    city,
    name,
    memberSince,
    experienceCount
  } = t0;
  let t1;
  if ($[0] !== city || $[1] !== tagline) {
    t1 = (tagline || city) && <p className="font-base-caption">{[tagline, city].filter(Boolean).join(" \xB7 ")}</p>;
    $[0] = city;
    $[1] = tagline;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== name) {
    t2 = <h1 className="font-heading1 tracking-[0.01em]">{name}</h1>;
    $[3] = name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex flex-col gap-1">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== memberSince) {
    t4 = memberSince && <Flag variant="outline">{`Mitglied seit ${formatMonthYear(memberSince)}`}</Flag>;
    $[8] = memberSince;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = experienceCount === 1 ? `${formatGermanNumber(experienceCount)} Erlebnis` : `${formatGermanNumber(experienceCount)} Erlebnisse`;
  let t6;
  if ($[10] !== t5) {
    t6 = <Flag variant="outline">{t5}</Flag>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <div className="flex flex-wrap gap-1">{t4}{t6}</div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t7) {
    t8 = <div className="flex flex-col gap-2">{t3}{t7}</div>;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}